'use strict';

//
import React from 'react';
import $, {extend} from 'jquery';
import classnames from 'classnames';


//
import Component from '../core/component';
import Enhance from '../core/enhance';

//
import {uuid, pick, strtotime, date} from '../libs/tools';
import Calendar from '../common/calendar';
import Directive from './directive';
import Popup from './popup';
import Iscroll from '../common/iscroll';
import {goBack, showMessage} from './handler';
import Page from "./page";
import Picker from './picker';


class Input extends Component {
    state = {}

    componentDidMount() {
    }

    render() {
        return this.renderInput()
    }

    /**
     *
     * @return {*}
     */
    renderInput() {
        switch (this.props.type) {
            case "date":
                return <InputDate ref="input" {...this.props}/>;
            case 'switch':
                return <InputSwitch ref="input" {...this.props}/>;
            case 'select':
                return <InputSelect ref="input" {...this.props}/>;
            case 'number':
                return <InputNumber ref="input" {...this.props}/>;
            default:
                return <InputText ref="input" {...this.props}/>
        }
    }

    /**
     *
     * @returns {*}
     * @public
     */
    getValue = () => {
        return this.refs.input.getValue();
    }


    /**
     *
     * @returns {*}
     */
    getElement = () => {
        return this.refs.input.getElement();
    }

}

/**
 *
 */
class InputDateTime extends Component {

}

/**
 *
 */
class InputDate extends Component {
    state = {
        uuid: uuid(),
        format: 'Y-m-d'
    }

    constructor(props, context) {
        super(props, context);
        extend(this.state, props, true);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {

        this.state.maxDatetime = strtotime(this.state.max);
        this.state.minDatetime = strtotime(this.state.min);
        this.state.datetime = strtotime(this.state.value);

        if (this.state.datetime > this.state.maxDatetime
            && this.state.maxDatetime !== false
            && this.state.datetime != false) {
            this.refs.input.value = this.state.value = this.state.max;
        }

        if (this.state.datetime < this.state.minDatetime
            && this.state.minDatetime !== false
            && this.state.datetime != false) {
            this.refs.input.value = this.state.value = this.state.min;
        }

        // 挂载完成 赋值
        this.refs.input.value = this.state.value || '';

    }


    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {

        // console.log(this.props, nextProps);
        extend(this.state, nextProps);

        this.state.maxDatetime = strtotime(this.state.max);
        this.state.minDatetime = strtotime(this.state.min);
        this.state.datetime = strtotime(this.state.value);

        // 判断最大时间范围
        if (this.props.max != nextProps.max
            && this.state.datetime > this.state.maxDatetime
            && this.state.maxDatetime !== false
            && this.state.datetime !== false
        ) {
            this.state.value = this.state.max;
            this.refs.input.value = this.state.value;
        }

        // 判断最小时间范围
        if (this.props.min != nextProps.min
            && this.state.datetime < this.state.minDatetime
            && this.state.minDatetime !== false
            && this.state.datetime !== false
        ) {
            this.state.value = this.state.min;
            this.refs.input.value = this.state.value;
        }

        //属性比对
        if (nextProps.value != this.props.value
            && this.state.maxDatetime == false
            && this.state.minDatetime == false) {
            this.refs.input.value = this.state.value || '';
        }
    }


    render() {
        return (
            <span>
                <input
                    name={this.state.name}
                    type="text"
                    autoComplete="off"
                    onClick={this.handlerClick}
                    readOnly={true}
                    ref="input"
                />
                <Directive name="Modal">
                   <Popup ref="popup">
                        <Page>
                            <Page.Header
                                title={''}
                                right={[{title: '关闭', onClick: goBack}]}
                            >
                            </Page.Header>
                            <Page.Content>
                                <Iscroll>
                                    <Calendar
                                        value={this.state.value}
                                        onValueChange={this.handlerValueChange}
                                        max={this.props.max}
                                        min={this.props.min}
                                    ></Calendar>
                                </Iscroll>
                            </Page.Content>
                        </Page>
                    </Popup>
                </Directive>
            </span>

        );
    }


    _handlerChange = (e) => {
        // 设置为只读属性时 不执行点击事件
        if (this.props.readOnly) {
            return;
        }
    }

    handlerClick(e) {
        // window.location.hash = this.state.uuid;
        this.refs.popup.show();
    }


    /**
     *
     * @param date
     * @private
     */
    handlerValueChange = (value) => {
        this.refs.input.value = value;

        if (this.state.value != value) {
            this.state.onValueChange && this.state.onValueChange(value);
        }
        this.state.value = value;
    }
}

/**
 *
 */
class InputText extends Component {
    state = {
        value: this.props.value || '',
    }

    constructor(props, context) {
        super(props, context)
    }

    /**
     * componentWillReceiveProps(object nextProps
     * 当一个挂载的组件接收到新的props的时候被调用。
     * 该方法应该用于比较this.props和nextProps，
     * 然后使用this.setState()来改变state。
     */
    componentWillReceiveProps(nextProps) {
        this.setState({value: nextProps.value});
    }

    render() {
        return (
            <input
                ref='input'
                name={this.props.name}
                type="text" value={this.state.value}
                autoComplete="off"
                onChange={this._handlerChange}
                readOnly={this.props.readOnly}
                disabled={this.props.disabled}
                placeholder={this.props.placeholder}
            />
        );
    }

    /**
     *
     * @returns {*}
     */
    getValue = () => {
        return this.refs.input.value;
    }

    /**
     *
     * @param e
     * @private
     */
    _handlerChange = (e) => {
        if (this.props.readOnly) {
            return;
        }
        this.setState({value: e.target.value});
        this.props.onValueChange && this.props.onValueChange(e.target.value);
    }

}

class InputSwitch extends Component {
    state = {
        checked: false
    }


    constructor(props, context) {
        super(props, context)
        this.state.checked = this.props.checked || false;
    }

    render() {
        return (
            <label className="label-switch">
                <input
                    type="checkbox"
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.state.checked}
                    onChange={this._handlerChange}
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                />
                <div className="checkbox"></div>
            </label>
        );


    }

    /**
     *
     * @private
     */
    _handlerChange = () => {
        if (this.props.readOnly) {
            return;
        }
        this.state.checked = !this.state.checked;
        this.props.onValueChange && this.props.onValueChange(this.state.checked);
        this.forceUpdate();
    }
}

/**
 *
 */
class InputSelect extends Component {
    state = {
        option: null,
        title: ''
    }

    constructor(props, context) {
        super(props, context);
        extend(this.state, props, true);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this._check();
    }

    /**
     * componentWillReceiveProps(object nextProps
     * 当一个挂载的组件接收到新的props的时候被调用。
     * 该方法应该用于比较this.props和nextProps，
     * 然后使用this.setState()来改变state。
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps, true);
        if (this.props.value != nextProps.value)
            this._check();
    }

    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        var props = extend({}, this.props);
        delete props.onChange;
        return (
            <div>
                <input
                    ref='input'
                    type="text"
                    value={this.state.title || ""}
                    autoComplete="off"
                    onChange={this._handlerChange}
                    readOnly={true}
                    placeholder={this.props.placeholder}
                    onClick={this.handlerClick}
                />
                <input type="hidden" name={this.props.name} value={this.state.selectedValue}/>
                <Directive name="Modal">
                    <Picker ref="picker" title={this.state.placeholder}>
                        <Iscroll>
                            {this.renderItemViews()}
                        </Iscroll>
                    </Picker>
                </Directive>
            </div>
        );
    }

    _check() {
        var selectedIndex = 0;
        var selectedValue = '';
        var title = '';
        if (this.state.value && this.state.option) {
            for (var i in this.state.option) {
                var item = this.state.option[i];
                if (item.value === this.state.value) {
                    selectedIndex = i;
                    title = item.title;
                    selectedValue = item.value;
                }
            }
        }
        this.setState({title, selectedIndex, selectedValue});
    }

    /**
     *
     * @returns {Array}
     * @private
     */
    renderItemViews() {
        var views = [];

        if (this.props.clear) {
            views.push(
                <div
                    key="clear"
                    className={classnames('picker-item', {active: !this.state.selectedValue})}
                    onClick={e => this._handlerItemClick({title: "", value: ""}, -1, e)}>
                    {this.props.clear}
                </div>
            )
        }

        $.each(this.state.option, (i, item) => {
            views.push(
                <div
                    key={item.value}
                    className={classnames('picker-item', {active: item.value == this.state.selectedValue})}
                    onClick={e => this._handlerItemClick(item, i, e)}>
                    {item.title}
                </div>
            )
        })
        return views;
    }

    /**
     *
     * @param item
     * @param selectedIndex
     * @private
     */
    _handlerItemClick(item, selectedIndex) {
        var {title, value} = item;
        this.setState({title, selectedValue: value, selectedIndex})
    }


    /**
     *
     * @param e
     * @private
     */
    _handlerChange(e) {
        if (this.props.readOnly) {
            return;
        }
        this.setState({value: e.target.value});
        this.props.onValueChange && this.props.onValueChange(e.target.value, e.target.selectedIndex);
    }

    /**
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    handlerClick(e) {
        e.stopPropagation();
        this.refs.picker.show();
        return false;
    }
}


class InputNumber extends Component {
    state = {
        value: this.props.value || '',
        num: 1
    }

    constructor(props, context) {
        super(props, context)
    }

    /**
     * componentWillReceiveProps(object nextProps
     * 当一个挂载的组件接收到新的props的时候被调用。
     * 该方法应该用于比较this.props和nextProps，
     * 然后使用this.setState()来改变state。
     */
    componentWillReceiveProps(nextProps) {
        this.setState({value: nextProps.value});
    }

    render() {
        return (
            <div className="c-input-number">
                <span className="c-input-number-left" onClick={this.handlerClickjian}>
                    <i style={{fontSize: '0.8rem'}} className="iconfont iconfont-jianhao"></i>
                </span>
                <input style={{width: '120px', textAlign: 'center  '}}
                       name={this.props.name}
                       type="text"
                       value={this.state.num}
                       autoComplete="off"
                       onChange={this._handlerChange}
                       readOnly={true}
                       disabled={this.props.disabled}

                />
                <span className="c-input-number-right" onClick={this.handlerClickjia}>
                    <i style={{fontSize: '0.8rem'}} className="iconfont iconfont-iconfontxinzeng"></i>
                </span>
            </div>
        );
    }

    /**
     *
     * @param e
     * @private
     */
    _handlerChange = (e) => {
        if (this.props.readOnly) {
            return;
        }
        this.setState({value: e.target.value});
        this.props.onValueChange && this.props.onValueChange(e.target.value);
    }

    handlerClickjia = () => {
        var num = parseFloat(this.state.num);
        num++;
        this.setState({num: num});
    }

    handlerClickjian = (e) => {
        if (this.state.num <= 1) {
            this.setState({num: 1});
        } else {
            var num = parseFloat(this.state.num);
            num--;
            this.setState({num: num});
        }

    }

}

//
Enhance(InputDate, {}, 'InputDate');
Enhance(InputDateTime, {}, 'InputDateTime');
Enhance(InputText, {}, 'InputText');
Enhance(InputSwitch, {}, 'InputSwitch');
Enhance(InputSelect, {}, 'InputSelect');
Enhance(InputNumber, {}, 'InputNumber');
Enhance(Input, {}, 'Input');
export default Input;
